export enum ConditionalHandlebarMacro {
  IfMatchesRegexStr = 'ifMatchesRegexStr',
  ContainsStr = 'containsStr',
  Not = 'not',
  Eq = 'eq',
  Lt = 'lt',
  Lte = 'lte',
  Gt = 'gt',
  Gte = 'gte',
}
